import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Factory, Cog, Users, Package, ListChecks, ClipboardEdit,
  TrendingUp, FileBarChart, BrainCircuit, Settings as SettingsIcon, LogOut, Clock, Wrench, Boxes,
} from "lucide-react";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "nav-dashboard" },
  { to: "/uretim-girisi", label: "Üretim Girişi", icon: ClipboardEdit, testid: "nav-production-entry", admin: true },
  { to: "/tamamlanan-urunler", label: "Tamamlanan Ürünler", icon: Boxes, testid: "nav-completed-products" },
  { to: "/bakim", label: "Bakım", icon: Wrench, testid: "nav-maintenance", admin: true },
  { to: "/trendler", label: "Trendler", icon: TrendingUp, testid: "nav-trends" },
  { to: "/raporlar", label: "Raporlar", icon: FileBarChart, testid: "nav-reports" },
  { to: "/ai-analiz", label: "AI Analiz", icon: BrainCircuit, testid: "nav-ai-analysis" },
  { to: "/bolumler", label: "Bölümler", icon: Factory, testid: "nav-departments", admin: true },
  { to: "/makineler", label: "Makineler", icon: Cog, testid: "nav-machines", admin: true },
  { to: "/personel", label: "Personel", icon: Users, testid: "nav-employees", admin: true },
  { to: "/vardiyalar", label: "Vardiya & Mesai", icon: Clock, testid: "nav-shifts", admin: true },
  { to: "/urunler", label: "Ürünler", icon: Package, testid: "nav-products", admin: true },
  { to: "/operasyonlar", label: "Operasyon & Standart", icon: ListChecks, testid: "nav-operations", admin: true },
  { to: "/ayarlar", label: "Ayarlar", icon: SettingsIcon, testid: "nav-settings", admin: true },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex bg-background" data-testid="app-layout">
      <aside className="w-60 shrink-0 border-r border-border bg-card flex flex-col fixed inset-y-0 z-30">
        <div className="px-5 py-5 border-b border-border">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded bg-primary flex items-center justify-center font-heading font-extrabold text-lg text-white">P</div>
            <div>
              <div className="font-heading font-bold leading-none tracking-tight">POWERMACHINES</div>
              <div className="text-[10px] text-muted-foreground mt-0.5">Üretim & Verimlilik Platformu</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3 px-2 space-y-0.5">
          {NAV.filter((n) => !n.admin || user?.role === "admin").map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 ${
                  isActive ? "bg-primary/15 text-primary font-medium" : "text-muted-foreground hover:bg-accent hover:text-foreground"
                }`}>
              <n.icon size={17} strokeWidth={1.8} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-3">
          <div className="text-xs text-muted-foreground truncate" data-testid="sidebar-user-name">{user?.name}</div>
          <div className="text-[10px] text-muted-foreground/70 truncate">{user?.email} · {user?.role === "admin" ? "Yönetici" : "Operatör"}</div>
          <Button variant="ghost" size="sm" data-testid="logout-button" onClick={logout}
            className="w-full mt-2 justify-start text-muted-foreground hover:text-destructive">
            <LogOut size={15} className="mr-2" /> Çıkış Yap
          </Button>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-w-0">
        <div className="max-w-[1400px] mx-auto px-6 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
